/**
 * TendrilLauncher — FAB (Floating Action Button) that opens the Tendril panel.
 *
 * Authenticated-only: only renders when useAuth().isAuthenticated is true.
 * Position: fixed bottom-right, z-index 150.
 *
 * BEM class: .tendril-launcher
 */
import React from 'react';
import { useAuth } from '../../auth/AuthContext.jsx';
import '../../styles/components/tendril.css';

/**
 * @param {{ onClick: () => void }} props
 */
export default function TendrilLauncher({ onClick }) {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) return null;

  return (
    <button
      className="tendril-launcher"
      onClick={onClick}
      aria-label="Open Tendril chat assistant"
      title="Tendril AI assistant"
      type="button"
    >
      {/*
        Banyan tree icon — stylised aerial-root silhouette.
        Central trunk + spreading canopy lobes + two hanging aerial roots,
        evoking the characteristic look of a banyan (Ficus benghalensis).
        32×32 viewBox; filled white against the brand-green FAB background.
      */}
      <svg
        aria-hidden="true"
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width="28"
        height="28"
        fill="white"
      >
        {/* Main trunk */}
        <rect x="14.5" y="18" width="3" height="11" rx="1.5" />
        {/* Central canopy dome */}
        <ellipse cx="16" cy="12" rx="9" ry="7" />
        {/* Left sub-canopy lobe */}
        <ellipse cx="8" cy="14" rx="5.5" ry="4.5" />
        {/* Right sub-canopy lobe */}
        <ellipse cx="24" cy="14" rx="5.5" ry="4.5" />
        {/* Left aerial root */}
        <path d="M8 18 Q6 22 7 28" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" />
        {/* Right aerial root */}
        <path d="M24 18 Q26 22 25 28" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" />
      </svg>
    </button>
  );
}
